window.addEventListener('DOMContentLoaded', function() {


    
    //Video preview
    if ( document.querySelector('.video_block._preview') ) {

        let previews = document.querySelectorAll('.video_block._preview')
        for ( let preview of previews ) {
            preview.addEventListener('click',  function() {
                let poster = this.querySelector('._poster')
                let video = this.querySelector('video')
                video.play()
                this.classList.remove('_preview')
                poster.remove()
            })                  
        }
    }

    if ( document.querySelector('.reviews ._slider') ) {
        const slider_reviews = new Swiper('.reviews ._slider', {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 20,
            duration: 1000,
            breakpoints: {
              900: {
                slidesPerView: 3,
                spaceBetween: 93
              }
            }
        })
    }

    if ( document.querySelector('.documents_section ._slider') ) {
        const slider_reviews = new Swiper('.documents_section ._slider', {
            slidesPerView: 'auto',
            loop: true,
            spaceBetween: 18,
            duration: 1000,
            breakpoints: {
              700: {
                spaceBetween: 30
              }
            },
            on: {
				init: function () {
                  if ( document.body.clientWidth > 900 ) {
  					document.querySelector('.documents_section ._slider .swiper-wrapper').style.transform = 'translate3d(-155px, 0px, 0px)'			
                  }
				}
			}
        })
    }
  
});